import type { Form } from 'factorial-form'
import { sortBy } from 'lodash'

import { type ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import { createForm } from 'modules/custom_resources/components/CustomFields/CustomFieldsForm/createForm'
import { isVisible } from 'modules/custom_resources/lib/utils'
import type ResourceField from 'modules/custom_resources/store/models/customFields/ResourceField'
import type CustomFieldValue from 'modules/custom_resources/store/models/customFields/Value'
import type Employee from 'modules/employees/store/models/Employee'

interface CustomFieldsForm {
  forms: Form[]
  isVisible: boolean
  hasCustomFieldTypes: boolean
}

export const getForm = (
  resourceFields: ResourceField[],
  fieldValues: CustomFieldValue[],
  contractVersions: ContractVersions,
  employee?: Employee
): CustomFieldsForm => {
  const visibleCustomFields = resourceFields.filter((resourceField) =>
    isVisible(employee, contractVersions)(resourceField.attributes.visible)
  )

  const forms = sortBy(visibleCustomFields, (field) => field.get('position')).map((field) =>
    createForm(field as any, fieldValues, contractVersions, employee)
  )

  return {
    forms: forms,
    isVisible: resourceFields.length > 0 && forms.length > 0,
    hasCustomFieldTypes: resourceFields.length > 0,
  }
}
